module.exports = __webpack_public_path__ + "img/okta_light_button.462db622.png";